export const routingConstants = {
  transcriber: '',
  login: 'login',
  noAccess: 'geen-toegang',
  manager: 'manager',
};
